export const formatCurrency = (amount, currency = null) => {
    const formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'GBP',
    });

    return formatter.format(amount);
}